var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsYoutube = function SvgPbsYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "YouTube"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.853 2.684a2.51 2.51 0 0 0-1.768-1.78c-1.559-.42-7.814-.42-7.814-.42s-6.254 0-7.813.42A2.51 2.51 0 0 0 .69 2.685C.27 4.254.27 7.53.27 7.53s0 3.275.419 4.845c.23.866.908 1.548 1.768 1.78 1.56.42 7.813.42 7.813.42s6.255 0 7.814-.42a2.51 2.51 0 0 0 1.768-1.78c.418-1.569.418-4.845.418-4.845s0-3.275-.418-4.846Zm-11.627 7.82V4.556l5.227 2.974z"
  })));
};
export default SvgPbsYoutube;